// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"product-list-item_wrapper__j4gfc","coverPhoto":"product-list-item_coverPhoto__jDqNj","cta":"product-list-item_cta__8ibbB","purchase":"product-list-item_purchase___NAlW"};